// extracted by mini-css-extract-plugin
module.exports = {"mainMenu":"Navigation_mainMenu__2DBAZ","items":"Navigation_items__1w5bW","active":"Navigation_active__CAVYS","hamburgerToggler":"Navigation_hamburgerToggler__2JIej"};